export default __webpack_public_path__ + "static/ABCBank_Thumbnail-66e391d0c27f6ce85b4b9236ab6396f4.png";